import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {ActivatedRoute, Params, Router} from '@angular/router';
import {AlertService} from '../services/alert.service';
import {EnvService} from '../services/env.service';
import { AuthService } from '../services/auth.service';

@Component({
  selector: 'micro-cmdb-mount-point-detail',
  templateUrl: './cmdb-mount-point-detail.component.html'
})
export class CmdbMountPointDetailComponent implements OnInit {
  @Input() cmdbMountPointId: any;
  @Output() persisted = new EventEmitter<any>();
  cmdbMountPoint: any;

  osTypeName: any = '';
  selectedOsType: any;

  statusName: any = '';
  selectedStatus: any;

  fileSystemName: any = '';
  selectedFileSystem: any;

  mountTypeName: any = '';
  selectedMountType: any;

  constructor(public auth: AuthService, private env: EnvService, private http: HttpClient, private route: ActivatedRoute,
              private router: Router, private alertService: AlertService) {
  }

  ngOnInit(): void {
    if (this.cmdbMountPointId) {
      this.load(this.cmdbMountPointId);

    } else {
      this.route.params.subscribe((params: Params) => {
        params['id'] === '0' ? this.createNew() : this.load(params['id']);
      });
    }
  }

  load(id: string): void {
    this.http.get(`${this.env.e.url}/domain/CmdbMountPoints/${id}`).subscribe(data => {
      this.cmdbMountPoint = data;
    });
  }

  createNew(): void {
    this.cmdbMountPoint = {
      name: '',
      osTypeId: '',
      purpose: '',
      statusId: '',
      typeId: '',
      fileSystemId: '',
      minSize: 0,
      maxSize: 0,
      seperateDisk: 'N',
      description: '',
      active: 'N',
      companyId: this.auth.getCompanyId()
    };
  }

  save(): void {
    const isUpdate = !!this.cmdbMountPoint.id;
    const request = isUpdate
      ? this.http.put(`${this.env.e.url}/domain/CmdbMountPoints/${this.cmdbMountPoint.id}`, this.cmdbMountPoint)
      : this.http.post(`${this.env.e.url}/domain/CmdbMountPoints`, this.cmdbMountPoint);
    request.subscribe(data => {
      this.cmdbMountPoint = data;
      this.alertService.info(`${isUpdate ? 'Updated' : 'Created'} ${this.cmdbMountPoint.name}`);
      this.persisted.emit({data, action: isUpdate ? 'updated' : 'added'});
    });
  }

  delete(): void {
    this.http.delete(`${this.env.e.url}/domain/CmdbMountPoints/${this.cmdbMountPoint.id}`).subscribe(() => {
      this.persisted.emit({data: this.cmdbMountPoint, action: 'deleted'});
      this.alertService.info(`Deleted ${this.cmdbMountPoint.name}`);
      if (!this.cmdbMountPointId) { this.router.navigate(['/mountPoints']); }
    });
  }

  onCheckboxChange(field: string, event: Event): void {
    const target = event.target as HTMLInputElement;
    this.cmdbMountPoint[field] = target.checked ? 'Y' : 'N';
  }

  onOsTypeChange(osType: any): void {
    this.selectedOsType = osType;
    this.osTypeName = osType ? osType.name : '';
  }

  onStatusChange(status: any): void {
    this.selectedStatus = status;
    this.statusName = status ? status.name : '';
  }

  onFileSystemChange(fileSystem: any): void {
    this.selectedFileSystem = fileSystem;
    this.fileSystemName = fileSystem ? fileSystem.name : '';
  }

  onMountTypeChange(mountType: any): void {
    this.selectedMountType = mountType;
    this.mountTypeName = mountType ? mountType.name : '';
  }
}
